import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { RouterProvider } from 'react-router-dom';
import { Provider } from 'react-redux';
import  { store,persistor } from './store/store';
import { PersistGate } from "redux-persist/integration/react";
import { GoogleOAuthProvider } from '@react-oauth/google';
import { initGA } from './analytics';
import router from './redesign/routing/router';

initGA();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

<GoogleOAuthProvider
clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
>
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      {/* Data router: RootShell (redesign/routing) is the persistent root
          layout — meta tags, GA tracker, scroll restoration, and the
          navigation-surviving audio player all live there. */}
      <RouterProvider router={router} />
    </PersistGate>
  </Provider>
  </GoogleOAuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
